import { HTTP } from './services';
import { GetURLRequestAccess } from '../config';

class LookupServices {

    constructor () {
        this.APIURL = 'generic/lookup/';
    }

    generateList(data, key) {
        return (data && data.length && data.map(e=> ({...e, label:e[key], value: e[key]}))) || [];
    }

    async lookup (queryParam, query, responsekey) {
        try {
            const response = await HTTP.GET(`${this.APIURL}?${queryParam}=${query}`);
            const result = response && response.responseListObject;
            return await this.generateList(result, responsekey? responsekey: queryParam);
        }
        catch(e) {
            console.error(e.toString());
        }
    }

    async lookupProducts() {
        try {
            
            const response = await HTTP.GET(`${this.APIURL}products`);
            const result = response && response.responseListObject;
            return await this.generateList(result, 'productName');
        }
        catch(e) {
            console.error(e.toString());
        }
    }

    async lookupTerritoryList(selectedProduct) {
        try {
           const response = await HTTP.GET(`${this.APIURL}territory?productName=${selectedProduct}`);
           const result = response && response.responseListObject;
           return await this.generateList(result, 'territoryName');
        }
        catch(e) {
            console.error(e.toString());
        }
    }

    async suggestionLookup() {
        try {
            const response = await HTTP.GET('generic/lookup?tag=ACTION');
            const result = response && response.responseListObject;
            console.log('result', result)
            return result;
        }
        catch(e) {
            console.error(e.toString());
        }
    }

    async suggestionLookupTagType({ tag, type, country_code }) {
        try {
            let isLookUp = true;
            let URL = `generic/lookup-tag-type?tag=${tag}&type=${type}&country_code=${country_code}`;
            const response = await HTTP.GET(GetURLRequestAccess(URL, isLookUp));
            const result = response && response.responseListObject;
            return result;
        }
        catch(e) {
            console.error(e.toString());
        }
    }


    async journeyScenario() {
        try {
            const response = await HTTP.GET('suggestions/journey-scenario');
            const result = response && response.responseListObject;
            return await this.generateList(result, 'value');
        }
        catch(e) {
            console.error(e.toString());
        }
    }
    
    async asset() {
      try {
        const response = await HTTP.GET(`${this.APIURL}asset`);
        const result = response && response.responseListObject;
        return await this.generateList(result, 'id');
      }
      catch (e) {
        console.error(e.toString());
      }
    }
  
    async surveyId() {
      try {
        const response = await HTTP.GET(`${this.APIURL}survey`);
        const result = response && response.responseListObject;
        return await this.generateList(result, 'id');
      }
      catch (e) {
        console.error(e.toString());
      }
    }

    async lookupStagesList() {
        try {
           const response = await HTTP.GET(`omni/stages`);
           const result = response && response.responseListObject;
           return await this.generateList(result, 'campaignStages');
        }
        catch(e) {
            console.error(e.toString());
        }
    }

   


    async assetSearch (request) {
        try {
            const response = await HTTP.POST(`${this.APIURL}elastic`,request );
            const result = await response && response.responseListObject;
            return result || [];
         }
         catch(e) {
             console.error(e.toString());
         }
    }

}

export default new LookupServices();